import socketIOClient from 'socket.io-client';

const ENDPOINT = process.env.REACT_APP_BFF_API.replace('/api', '');

export const socket = socketIOClient(ENDPOINT);
